import React from 'react'
import { useTranslation } from 'react-i18next'
import { CheckInfluencerIcon } from 'Stories/Icon/Icon.stories'
import { colors } from 'Styled/variables'
import { InfluencerRegisterEnum } from '../../../../Types'

import { StatusProps } from './StatusProps'
import { MainWrapper, Circle, InnerWrapper, Divider, Text } from './styles'

const Status: React.FC<StatusProps> = ({ status }) => {
  const { t } = useTranslation()

  return (
    <MainWrapper>
      <div>
        <InnerWrapper>
          <Circle status>
            {status === InfluencerRegisterEnum.CONNECT ||
            status === InfluencerRegisterEnum.ERROR ||
            status === InfluencerRegisterEnum.CONNECTED ? (
              1
            ) : (
              <CheckInfluencerIcon />
            )}
          </Circle>
          <Divider status />
        </InnerWrapper>

        <Text
          color={
            status === InfluencerRegisterEnum.CONNECT ||
            status === InfluencerRegisterEnum.ERROR ||
            status === InfluencerRegisterEnum.CONNECTED
              ? colors.green
              : colors.mainText
          }
          align="left"
        >
          {t('influencer.connectYourAccount')}
        </Text>
      </div>

      <div>
        <InnerWrapper>
          <Divider
            status={
              status === InfluencerRegisterEnum.FORM ||
              status === InfluencerRegisterEnum.CONFIRMATION
            }
          />
          <Circle
            status={
              status === InfluencerRegisterEnum.FORM ||
              status === InfluencerRegisterEnum.CONFIRMATION
            }
          >
            2
          </Circle>
        </InnerWrapper>

        <Text
          color={
            status === InfluencerRegisterEnum.CONNECT ||
            status === InfluencerRegisterEnum.CONNECTED
              ? colors.greyTextBlackBg
              : colors.green
          }
          align="right"
        >
          {t('influencer.setAccountAccess')}
        </Text>
      </div>
    </MainWrapper>
  )
}

export default Status
